import {API_HOST_NAME} from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useServiceCronJobsResources = (teamId, projectId, serviceId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/services/${serviceId}/cron_jobs`;
  return useAuthenticatedResources(url)
}

export default useServiceCronJobsResources;
